import { createError } from '@common/neo.tax';
import * as Sentry from '@sentry/browser';

import { FileUploadsState, ToastConfigState } from '../state';
import { ResumableFileUpload } from '../state/fileUploadsVar';
import { fetchAuthenticatedLocationUrl, uploadFile } from '../third-parties';

export const initiateResumableFileUpload = async ({
  fileUpload,
  getUploadUrl,
  onFinishedUploading,
}: {
  fileUpload: ResumableFileUpload;
  getUploadUrl: () => PromiseLike<{ permanentUrl: string; signedUrl: string }>;
  onFinishedUploading: (permanentUrl: string) => PromiseLike<void>;
}): Promise<void> => {
  try {
    // get a signed url from our backend to upload the file to
    const { permanentUrl, signedUrl } = await getUploadUrl();

    const locationUrl = await fetchAuthenticatedLocationUrl(signedUrl, fileUpload.file.type);

    fileUpload.cloudStorageLocationUrl = locationUrl;
    FileUploadsState.updateFileUpload(fileUpload);

    await uploadFile(locationUrl, fileUpload.file, (percent: number) =>
      FileUploadsState.setUploadPercent(fileUpload.file.name, percent),
    );
    FileUploadsState.removeFileUpload(fileUpload.file.name);
    await onFinishedUploading(permanentUrl);

    ToastConfigState.pushSuccessToast('Successfully uploaded files.', {
      duration: 'MEDIUM',
    });
  } catch (error) {
    fileUpload.cloudStorageLocationUrl = null;
    fileUpload.uploadPercent = 0;
    FileUploadsState.updateFileUpload(fileUpload);

    ToastConfigState.pushErrorToast('Failed To Uploaded Files. Please try again.', {
      duration: 'LONG',
    });

    Sentry.addBreadcrumb({ level: 'error', data: { error } });
    Sentry.captureException(createError('FileUploadError', 'Resumable upload failed, see breadcrumb'));
    console.error(error);
  }
};
